export const BORROW_TERM_DAYS = [7, 30, 60, 90];
export const NON_NUMERIC = /\D+/g;
export const INITIAL_RATES = [
  { rate: '15%', cost: null, label: '15%' },
  { rate: '25%', cost: null, label: '25%' },
  { rate: '35%', cost: null, label: '35%' }
];

export const isValidBorrowAmount = (amount) => {
  return amount > 0 && amount <= 5000;
};

export const debounce = (inner, ms = 0) => {
  let timer = null;
  let resolves = [];

  return function (...args) {
    // Run the function after a certain amount of time
    clearTimeout(timer);
    timer = setTimeout(() => {
      // Get the result of the inner function, then apply it to the resolve function of
      // each promise that has been created since the last time the inner function was run
      let result = inner(...args);
      resolves.forEach((r) => r(result));
      resolves = [];
    }, ms);

    return new Promise((r) => resolves.push(r));
  };
};

export const cleanBorrowAmount = (amount, regex) => {
  if (amount === '') return 0;

  // Remove regex chars from our string
  return Number(amount.replace(regex, ''));
};

export const setRangeSliderCSSVariables = (field, currentAmount) => {
  // Adjust CSS vars based on borrow amount and input range
  field.style.setProperty('--rs-min', field.min);
  field.style.setProperty('--rs-max', field.max);
  field.style.setProperty('--rs-value', currentAmount);
};
